<template>
  <div id="common-modal" name="modal">
    <div class="modal-mask" @click="hideModal">
    </div>
    <div class="modal-wrapper">
      <div class="modal-container">
        <button class="modal-default-button close-btn" @click="hideModal">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
            <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"/>
          </svg>
        </button>

        <div class="modal-header">
          <div class="svg-wrap">
            <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" fill="#00BB23" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
              <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
            </svg>
          </div>
        </div>
        <div class="modal-body">
          <p v-html="this.text"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CommonModal",
  props: [
    'text'
  ],
  methods: {
    hideModal() {
      this.$emit('close');
      document.body.classList.remove("modal-open")
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
#common-modal {
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

#common-modal .modal-mask {
  position: fixed;
  z-index: 99;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}
#common-modal .modal-header{
  display: block !important;
  border-bottom: 0 !important;
  text-align: center;
}
#common-modal .modal-header .svg-wrap{
  display: block;
}

#common-modal .modal-wrapper {
  width: 400px;
  display: table;
  vertical-align: middle;
  z-index: 100;
  position: fixed;
  right: 0;
  bottom: 0;
  left: 50%;
  top: 50%;
  transform: translate(-25%, -50%);
  animation: fadein .5s;
  -moz-animation: fadein .5s; /* Firefox */
  -webkit-animation: fadein .5s; /* Safari and Chrome */
  -o-animation: fadein .5s; /* Opera */
}
@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-moz-keyframes fadein { /* Firefox */
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-webkit-keyframes fadein { /* Safari and Chrome */
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-o-keyframes fadein { /* Opera */
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@media only screen and (max-width: 991px) {
  #common-modal .modal-wrapper {
    transform: translate(-50%, -50%);
  }
}
@media only screen and (max-width: 767px) {
  #common-modal .modal-wrapper {
    width: 100%;
    padding: 15px;
  }
}

#common-modal .modal-container {
  width: 100%;
  margin: 0 auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  position: relative;
}

#common-modal .modal-body {
  margin: 0;
}
@media only screen and (max-width: 575px) {
  #common-modal .modal-body {
    margin: 0;
  }
}

#common-modal .modal-default-button {
  border: 0;
  background: none;
  color: #333333;
  position: absolute;
  left: 90%;
  top: 10px;
}
@media only screen and (min-width: 991px) {
  #common-modal .modal-default-button:hover{
    color: black;
  }
}
@media only screen and (max-width: 525px) {
  #common-modal .modal-default-button{
    left: 80%;
  }
}

#common-modal .modal-header .modal-title{
  font-size: 20px;
  margin-top: 10px;
  color: #00bb23;
  font-weight: bold;
}
#common-modal .modal-body .text-content{
  font-size: 16px;
}
@media only screen and (max-width: 525px) {
  #common-modal .modal-header .modal-title{
    font-size: 24px;
  }
  #common-modal .modal-body .text-content, #common-modal .modal-body p.text-content + ul{
    font-size: 14px;
  }
  #common-modal .modal-body p.text-content + ul{
    padding-left: 1rem;
    text-indent: -1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CommonModal.vue